
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBatteryVerticalChargingEmpty as ObiBatteryVerticalChargingEmptyElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-battery-vertical-charging-empty.js';
 
 
 

 
 export const ObiBatteryVerticalChargingEmpty = createComponent({
   react: React,
   tagName: 'obi-battery-vertical-charging-empty',
   elementClass: ObiBatteryVerticalChargingEmptyElement,
   events: {
     
   }
  });
 
 